/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AccessPlanPurchaseSummary } from './AccessPlanPurchaseSummary';
import { CoursePurchaseSummary } from './CoursePurchaseSummary';
const PurchaseGrantParser = /* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('purchase')],
    [
        'purchase',
        /* #__PURE__ */ parsers.taggedUnion('scope', [
            ['access-plan', AccessPlanPurchaseSummary],
            ['course', CoursePurchaseSummary],
        ]),
    ],
]);
export class PurchaseGrant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PurchaseGrantParser.decode(input).map(res => new PurchaseGrant(res));
    }
    static unsafeDecode(input) {
        return PurchaseGrant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PurchaseGrantParser.encode(data);
    }
    static schema() {
        return PurchaseGrantParser.schema();
    }
}
